import { Controller, FieldValues, Control, Path } from "react-hook-form"
import { DateTimePicker } from "@mui/x-date-pickers"

import dayjs, { Dayjs } from "dayjs"

interface ControlledDatePickerProps<T extends FieldValues> {
  label: string
  name: Path<T>
  control: Control<T>
}

const ControlledDatePicker = <T extends FieldValues>({
  label,
  control,
  name,
}: ControlledDatePickerProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, onChange, value } }) => {
        return (
          <DateTimePicker
            label={label}
            inputRef={ref}
            value={value && dayjs(value).isValid() ? dayjs(value) : null}
            onChange={(date: Dayjs | null) => {
              onChange(dayjs(date).toDate())
            }}
          />
        )
      }}
    />
  )
}

export default ControlledDatePicker
